import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { EventEmitter, uid, isPow2, BaseTextureCache, TextureCache } from '@pixi/utils';
import { SCALE_MODES, FORMATS, ALPHA_MODES, TYPES, TARGETS } from '@pixi/constants';
import { Resource } from './resources/Resource.mjs';
import { BufferResource } from './resources/BufferResource.mjs';
import { autoDetectResource } from './resources/autoDetectResource.mjs';
import { settings } from '@pixi/settings';
var defaultBufferOptions = {
  scaleMode: SCALE_MODES.NEAREST,
  format: FORMATS.RGBA,
  alphaMode: ALPHA_MODES.NPM
};
var _BaseTexture = /*#__PURE__*/function (_EventEmitter) {
  _inherits(_BaseTexture, _EventEmitter);
  var _super = _createSuper(_BaseTexture);
  function _BaseTexture() {
    var _this;
    var resource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, _BaseTexture);
    _this = _super.call(this);
    options = options || {};
    var _options = options,
      alphaMode = _options.alphaMode,
      mipmap = _options.mipmap,
      anisotropicLevel = _options.anisotropicLevel,
      scaleMode = _options.scaleMode,
      width = _options.width,
      height = _options.height,
      wrapMode = _options.wrapMode,
      format = _options.format,
      type = _options.type,
      target = _options.target,
      resolution = _options.resolution,
      resourceOptions = _options.resourceOptions;
    if (resource && !(resource instanceof Resource)) {
      resource = autoDetectResource(resource, resourceOptions);
      resource.internal = true;
    }
    _this.resolution = resolution || settings.RESOLUTION;
    _this.width = Math.round((width || 0) * _this.resolution) / _this.resolution;
    _this.height = Math.round((height || 0) * _this.resolution) / _this.resolution;
    _this._mipmap = mipmap !== null && mipmap !== void 0 ? mipmap : settings.MIPMAP_TEXTURES;
    _this.anisotropicLevel = anisotropicLevel !== null && anisotropicLevel !== void 0 ? anisotropicLevel : settings.ANISOTROPIC_LEVEL;
    _this._wrapMode = wrapMode || settings.WRAP_MODE;
    _this._scaleMode = scaleMode !== null && scaleMode !== void 0 ? scaleMode : settings.SCALE_MODE;
    _this.format = format || FORMATS.RGBA;
    _this.type = type || TYPES.UNSIGNED_BYTE;
    _this.target = target || TARGETS.TEXTURE_2D;
    _this.alphaMode = alphaMode !== null && alphaMode !== void 0 ? alphaMode : ALPHA_MODES.UNPACK;
    _this.uid = uid();
    _this.touched = 0;
    _this.isPowerOfTwo = false;
    _this._refreshPOT();
    _this._glTextures = {};
    _this.dirtyId = 0;
    _this.dirtyStyleId = 0;
    _this.cacheId = null;
    _this.valid = width > 0 && height > 0;
    _this.textureCacheIds = [];
    _this.destroyed = false;
    _this.resource = null;
    _this._batchEnabled = 0;
    _this._batchLocation = 0;
    _this.parentTextureArray = null;
    _this.setResource(resource);
    return _this;
  }
  _createClass(_BaseTexture, [{
    key: "realWidth",
    get: function get() {
      return Math.round(this.width * this.resolution);
    }
  }, {
    key: "realHeight",
    get: function get() {
      return Math.round(this.height * this.resolution);
    }
  }, {
    key: "mipmap",
    get: function get() {
      return this._mipmap;
    },
    set: function set(value) {
      if (this._mipmap !== value) {
        this._mipmap = value;
        this.dirtyStyleId++;
      }
    }
  }, {
    key: "scaleMode",
    get: function get() {
      return this._scaleMode;
    },
    set: function set(value) {
      if (this._scaleMode !== value) {
        this._scaleMode = value;
        this.dirtyStyleId++;
      }
    }
  }, {
    key: "wrapMode",
    get: function get() {
      return this._wrapMode;
    },
    set: function set(value) {
      if (this._wrapMode !== value) {
        this._wrapMode = value;
        this.dirtyStyleId++;
      }
    }
  }, {
    key: "setStyle",
    value: function setStyle(scaleMode, mipmap) {
      var dirty;
      if (scaleMode !== void 0 && scaleMode !== this.scaleMode) {
        this.scaleMode = scaleMode;
        dirty = true;
      }
      if (mipmap !== void 0 && mipmap !== this.mipmap) {
        this.mipmap = mipmap;
        dirty = true;
      }
      if (dirty) {
        this.dirtyStyleId++;
      }
      return this;
    }
  }, {
    key: "setSize",
    value: function setSize(desiredWidth, desiredHeight, resolution) {
      resolution = resolution || this.resolution;
      return this.setRealSize(desiredWidth * resolution, desiredHeight * resolution, resolution);
    }
  }, {
    key: "setRealSize",
    value: function setRealSize(realWidth, realHeight, resolution) {
      this.resolution = resolution || this.resolution;
      this.width = Math.round(realWidth) / this.resolution;
      this.height = Math.round(realHeight) / this.resolution;
      this._refreshPOT();
      this.update();
      return this;
    }
  }, {
    key: "_refreshPOT",
    value: function _refreshPOT() {
      this.isPowerOfTwo = isPow2(this.realWidth) && isPow2(this.realHeight);
    }
  }, {
    key: "setResolution",
    value: function setResolution(resolution) {
      var oldResolution = this.resolution;
      if (oldResolution === resolution) {
        return this;
      }
      this.resolution = resolution;
      if (this.valid) {
        this.width = Math.round(this.width * oldResolution) / resolution;
        this.height = Math.round(this.height * oldResolution) / resolution;
        this.emit("update", this);
      }
      this._refreshPOT();
      return this;
    }
  }, {
    key: "setResource",
    value: function setResource(resource) {
      if (this.resource === resource) {
        return this;
      }
      if (this.resource) {
        throw new Error("Resource can be set only once");
      }
      resource.bind(this);
      this.resource = resource;
      return this;
    }
  }, {
    key: "update",
    value: function update() {
      if (!this.valid) {
        if (this.width > 0 && this.height > 0) {
          this.valid = true;
          this.emit("loaded", this);
          this.emit("update", this);
        }
      } else {
        this.dirtyId++;
        this.dirtyStyleId++;
        this.emit("update", this);
      }
    }
  }, {
    key: "onError",
    value: function onError(event) {
      this.emit("error", this, event);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.resource) {
        this.resource.unbind(this);
        if (this.resource.internal) {
          this.resource.destroy();
        }
        this.resource = null;
      }
      if (this.cacheId) {
        delete BaseTextureCache[this.cacheId];
        delete TextureCache[this.cacheId];
        this.cacheId = null;
      }
      this.dispose();
      _BaseTexture.removeFromCache(this);
      this.textureCacheIds = null;
      this.destroyed = true;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.emit("dispose", this);
    }
  }, {
    key: "castToBaseTexture",
    value: function castToBaseTexture() {
      return this;
    }
  }], [{
    key: "from",
    value: function from(source, options) {
      var strict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : settings.STRICT_TEXTURE_CACHE;
      var isFrame = typeof source === "string";
      var cacheId = null;
      if (isFrame) {
        cacheId = source;
      } else {
        if (!source._pixiId) {
          var prefix = (options === null || options === void 0 ? void 0 : options.pixiIdPrefix) || "pixiid";
          source._pixiId = "".concat(prefix, "_").concat(uid());
        }
        cacheId = source._pixiId;
      }
      var baseTexture = BaseTextureCache[cacheId];
      if (isFrame && strict && !baseTexture) {
        throw new Error("The cacheId \"".concat(cacheId, "\" does not exist in BaseTextureCache."));
      }
      if (!baseTexture) {
        baseTexture = new _BaseTexture(source, options);
        baseTexture.cacheId = cacheId;
        _BaseTexture.addToCache(baseTexture, cacheId);
      }
      return baseTexture;
    }
  }, {
    key: "fromBuffer",
    value: function fromBuffer(buffer, width, height, options) {
      buffer = buffer || new Float32Array(width * height * 4);
      var resource = new BufferResource(buffer, {
        width: width,
        height: height
      });
      var type = buffer instanceof Float32Array ? TYPES.FLOAT : TYPES.UNSIGNED_BYTE;
      return new _BaseTexture(resource, Object.assign({}, defaultBufferOptions, options || {
        width: width,
        height: height,
        type: type
      }));
    }
  }, {
    key: "addToCache",
    value: function addToCache(baseTexture, id) {
      if (id) {
        if (!baseTexture.textureCacheIds.includes(id)) {
          baseTexture.textureCacheIds.push(id);
        }
        if (BaseTextureCache[id] && BaseTextureCache[id] !== baseTexture) {
          console.warn("BaseTexture added to the cache with an id [".concat(id, "] that already had an entry"));
        }
        BaseTextureCache[id] = baseTexture;
      }
    }
  }, {
    key: "removeFromCache",
    value: function removeFromCache(baseTexture) {
      if (typeof baseTexture === "string") {
        var baseTextureFromCache = BaseTextureCache[baseTexture];
        if (baseTextureFromCache) {
          var index = baseTextureFromCache.textureCacheIds.indexOf(baseTexture);
          if (index > -1) {
            baseTextureFromCache.textureCacheIds.splice(index, 1);
          }
          delete BaseTextureCache[baseTexture];
          return baseTextureFromCache;
        }
      } else if (baseTexture !== null && baseTexture !== void 0 && baseTexture.textureCacheIds) {
        for (var i = 0; i < baseTexture.textureCacheIds.length; ++i) {
          delete BaseTextureCache[baseTexture.textureCacheIds[i]];
        }
        baseTexture.textureCacheIds.length = 0;
        return baseTexture;
      }
      return null;
    }
  }]);
  return _BaseTexture;
}(EventEmitter);
var BaseTexture = _BaseTexture;
BaseTexture._globalBatch = 0;
export { BaseTexture };